<template>
  <Modal
    :show="discountDetailsStore.visible"
    :closable="true"
    @onClose="handleClose"
  >
    <div class="discount_details">
      <div class="discount_details_title mb-40">优惠明细</div>
      <GoodsCheckBox
        :loading="loading"
        :rowKey="GOODS_UNIQUE_ID"
        :dataSource="list"
        @onChange="handleChange"
      />
      <DiscountPrice
        :loading="priceLoading || loading"
        class="mt-18 pl-26 pr-26"
        :deliveryPriceInfo="deliveryPriceInfo"
      />
      <Button
        class="pos_hor_center select_n check_btn"
        loadingText="提交中..."
        :loading="submitting"
        :disabled="selectedNum <= 0"
        @click="handleSubmit"
        :latag="`latag_pc_购物车_优惠明细弹窗_去结算按钮_null_null`"
      >
        {{ renderCheckoutBtnText(deliveryPriceInfo?.checkoutButtonType) }} ({{ selectedNum }})
      </Button>
    </div>
  </Modal>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import useDiscountDetailsStore from "@shared/store/useDiscountDetailsStore";
import { formatCartGoods } from "@shared/utils";
import { activeItem, getCartList, submitCart } from "@shared/services";
import { Bridge } from "@shared/bridge";
import { CHECKOUT_BTN_TYPE } from "@shared/constants";
import Modal from "../../components/Modal";
import GoodsCheckBox from "../GoodsCheckBox";
import DiscountPrice from "../DiscountPrice";
import Button from "../../components/Button";
import { beforeGoToCheckout, toast } from "@shared/utils/biz_utils";

const discountDetailsStore = useDiscountDetailsStore();
const loading = ref(false);
const priceLoading = ref(false);
const submitting = ref(false);
const selectedNum = ref(0);
const deliveryPriceInfo = ref({}); // 优惠明细价格动态展示对象
const list = ref([]);

const GOODS_UNIQUE_ID = "_itemId"; // 商品唯一key
// 弹层只展示已选中的数据
const filterCheckedGoods = (goodsList = []) => {
  return goodsList?.filter((goods) => goods?._isChecked);
};

// 渲染按钮不同文案
const renderCheckoutBtnText = (type = 0) => {
  const BTN_TEXT_MAP = {
    [CHECKOUT_BTN_TYPE.NORMAL_CHECKOUT]: "去结算",
    [CHECKOUT_BTN_TYPE.GET_COUPON_CHECKOUT]: "领券结算",
  };
  return BTN_TEXT_MAP[type] || "去结算";
};
// 获取购物车数数据
const handleFetchData = () => {
  loading.value = true;
  getCartList()
    .then((res) => {
      if (!res?.success) {
        toast(res?.resultMsg);
        return;
      }
      const formattedGoods = formatCartGoods(res);
      const filteredGoods = filterCheckedGoods(formattedGoods);

      list.value = filteredGoods;
      selectedNum.value = filteredGoods?.length || 0;
      renderDiscountColPrice(res?.t?.deliveryPriceInfo || {});
    })
    .catch((err) => {
      console.log("get cart list error catch:", err);
    })
    .finally(() => {
      loading.value = false;
    });
};

watchEffect(() => {
  if (discountDetailsStore.visible) {
    document.querySelector("body").classList.add("withoutScroll");
    handleFetchData();
  } else {
    document.querySelector("body").classList.remove("withoutScroll");
  }
});

const handleClose = () => {
  discountDetailsStore.toggle();
  handleReRednerCart();
};

// 重新更新购物车信息
const handleReRednerCart = () => {
  getCartList().then((data) => {
    if (!data?.success) {
      toast(data?.resultMsg);
      return;
    }
    Bridge.emit(Bridge.EventType.renderCart, data);
  });
};

// 更新优惠明细栏目信息
const renderDiscountColPrice = (data = {}) => {
  deliveryPriceInfo.value = data;
};

// 商品checkbox
const handleChange = (goods = {}, isChecked = false, allSelectedGoods = []) => {
  selectedNum.value = allSelectedGoods.length || 0;
  priceLoading.value = true;
  activeItem({
    itemId: goods[GOODS_UNIQUE_ID],
    active: isChecked,
    terminal: window._terminal,
    shopId: window._shopId,
  })
    .then((res) => {
      renderDiscountColPrice(res?.t?.deliveryPriceInfo || {});
      handleReRednerCart();
    })
    .catch((err) => {
      console.log("修改选中状态失败：", err);
    })
    .finally(() => {
      priceLoading.value = false;
    });
};

const handleSubmit = () => {
  submitting.value = true;
  submitCart({ terminal: window._terminal })
    .then((res) => {
      beforeGoToCheckout(res);
    })
    .catch((err) => {
      console.lohg("购物车提交异常捕获：", err);
    })
    .finally(() => {
      submitting.value = false;
    });
};
</script>

<style scoped lang="less">
.discount_details {
  background-color: #fff;
  border-radius: 4px;
  width: 584px;
  // min-height: 500px;
  position: relative;
  padding: 30px 54px 30px 54px;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  &_title {
    font-size: 23px;
    color: #252525;
    letter-spacing: 0;
    line-height: 23px;
    font-weight: 600;
    text-align: center;
  }

  &_topay {
    background: #ef1e0b;
    font-size: 13px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 400;
    padding: 12px 66px;
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);
    position: relative;
    user-select: none;
  }
  .check_btn {
    // margin-bottom: 0;
  }
}
</style>
